import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=c0f41184&"
import script from "./UserOrders.vue?vue&type=script&lang=js&"
export * from "./UserOrders.vue?vue&type=script&lang=js&"
import style0 from "./UserOrders.vue?vue&type=style&index=0&id=c0f41184&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports